import { z } from 'zod';

/**
 * Zod schema for enroll_user_in_portal RPC response
 * Validates the response structure from the database function
 */

// Schema for portal_type enum
const PortalTypeSchema = z.enum(['lexlabour', 'lexzone', 'lexwoo', 'lex']);

export const EnrollmentResultSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  portals: z.array(PortalTypeSchema),
});

export type EnrollmentResult = z.infer<typeof EnrollmentResultSchema>;
